import { render } from "./HorseEditMainPedigree.vue?vue&type=template&id=5a9f33cc"
import script from "./HorseEditMainPedigree.vue?vue&type=script&lang=js"
export * from "./HorseEditMainPedigree.vue?vue&type=script&lang=js"

import "./HorseEditMainPedigree.vue?vue&type=style&index=0&id=5a9f33cc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__